export default __webpack_public_path__ + "static/media/ScienceTonic.98114ecf44bdde72557f0c54bac1876e.webp";